export default "__VITE_ASSET__BYs7_xP5__"